import { createContext } from 'react';

import { ScrollContainerContextValue } from '../types';

export const ScrollContainerContext =
  createContext<ScrollContainerContextValue>({
    scrollContainerWidth: undefined,
  });
